import { IconProps } from "../../types/utils";

const LikeIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 20}
    height={dimension || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3671 3.84124C16.9415 3.41541 16.4361 3.07761 15.8799 2.84714C15.3237 2.61667 14.7275 2.49805 14.1254 2.49805C13.5234 2.49805 12.9272 2.61667 12.371 2.84714C11.8147 3.07761 11.3094 3.41541 10.8838 3.84124L10.0004 4.72457L9.11709 3.84124C8.25735 2.98149 7.09128 2.49849 5.87542 2.49849C4.65956 2.49849 3.4935 2.98149 2.63376 3.84124C1.77401 4.70098 1.29102 5.86704 1.29102 7.0829C1.29102 8.29876 1.77401 9.46483 2.63376 10.3246L3.51709 11.2079L10.0004 17.6912L16.4838 11.2079L17.3671 10.3246C17.7929 9.89894 18.1307 9.39358 18.3612 8.83736C18.5917 8.28115 18.7103 7.68497 18.7103 7.0829C18.7103 6.48083 18.5917 5.88465 18.3612 5.32844C18.1307 4.77222 17.7929 4.26687 17.3671 3.84124Z"
      fill="#EEEEEE"
      stroke="#CBD1D9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LikeIcon;
